export const TIME_HEADER_HEIGHT = 8 * 5.5;
export const LINE_WIDTH = 8 * 0.25;
export const SIDE_HEADER_WIDTH = 8 * 13;
export const ROTATION_FIRST_MARGIN = 8 * 0.5;
export const ROTATION_MINI_HEIGHT = 8 * 3; // Calendar rotation height
export const ROTATION_MINI_MARGIN = 8 * 0.25;
export const ROTATION_SLIM_HEIGHT = 8 * 4;
export const ROTATION_SLIM_MARGIN = 8 * 1.5;
export const ROTATION_COMFORM_HEIGHT = 8 * 7;
export const ROTATION_COMFORM_MARGIN = 8 * 3;

export const ROTATION_HEIGHT = {
	small: ROTATION_MINI_HEIGHT,
	medium: ROTATION_SLIM_HEIGHT,
	large: ROTATION_COMFORM_HEIGHT,
};

export const ROTATION_MARGIN = {
	small: ROTATION_MINI_MARGIN,
	medium: ROTATION_SLIM_MARGIN,
	large: ROTATION_COMFORM_MARGIN,
};

export enum TimeDisplay {
	Hour = 'hourly',
	/* Short daily view */
	VerticalDay = 'short',
	/* Long daily view */
	HorizontalDay = 'long',
}
